import type * as React from 'react';

/**
 * Shared hover/focus handlers for rows inside the header popovers
 * (CollectionSwitcher, AccountMenu). Matches the old sidebar "More" popover
 * treatment: gold[50] background + warmGray[800] text on hover/focus,
 * transparent + warmGray[600] at rest.
 *
 * Hoisted to module scope so every popover row shares one object identity
 * across renders (no per-render allocation). Inline style mutation is
 * required because the rows use inline `style` props for their resting
 * color — CSS pseudo-selectors cannot override inline styles.
 */
export const POPOVER_ROW_HOVER_HANDLERS = {
  onMouseEnter: (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = 'var(--primary-40)';
    e.currentTarget.style.color = 'var(--text-primary)';
  },
  onMouseLeave: (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = 'transparent';
    e.currentTarget.style.color = 'var(--text-secondary)';
  },
  onFocus: (e: React.FocusEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = 'var(--primary-40)';
    e.currentTarget.style.color = 'var(--text-primary)';
  },
  onBlur: (e: React.FocusEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = 'transparent';
    e.currentTarget.style.color = 'var(--text-secondary)';
  },
} as const;
